export default "__VITE_ASSET__B0tvNfD4__"